import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import NeighborhoodWatchlist from "@/pages/NeighborhoodWatchlist";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/neighborhood-watchlist")({
  head: () => seoHead("/neighborhood-watchlist"),
  component: () => (
    <AuthGate><NeighborhoodWatchlist /></AuthGate>
  ),
});
